import { ruRU } from '@material-ui/core/locale';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import {
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import Layout from './Layout';
import OrderView from './OrderView';
import PersonalDataPolicy from './PersonalDataPolicy';
import SearchOrderForm from './SearchOrderForm';
import StatementView from './StatementView';

// Create a theme instance.
const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Ubuntu',
      'Arial',
      'sans-serif'
    ].join(','),
  },
  palette: {
    primary: {
      main: '#414452',
    },
    secondary: {
      main: '#19857b',
    },
    background: {
      default: '#f2f3f7',
    },
  },
}, ruRU);

function App() {
  return (

    <ThemeProvider theme={theme}>
      <Router>
        <Switch>
          <Route exact path="/">
            <Layout>
              <SearchOrderForm />
            </Layout>
          </Route>
          <Route path="/order">
            <OrderView />
          </Route>
          <Route path="/statement">
            <StatementView />
          </Route>
          <Route path="/personal-data-policy">
            <PersonalDataPolicy />
          </Route>
        </Switch>
      </Router>
    </ThemeProvider>
  );
}

export default App;
